import axiosService from './axiosService';
import authService from './authService';

class SavedSearchService {
  saveSearch = (data) => axiosService.post('/api/saved-searches', data);

  getSavedSearches = () => axiosService.get(`/api/saved-searches/users/${authService.getUserId()}`);

  deleteSavedSearch = (searchId) => axiosService.delete(`/api/saved-searches/${searchId}`);
}

const savedSearchService = new SavedSearchService();
export default savedSearchService;
